import { Link as GatsbyLink } from "gatsby";
import React from "react";

const Link = ({ children, external, to, ...props }) => {
  if (external) {
    if (to.indexOf("flexa.network") < 0) {
      props.target = "_blank";
    }
    return (
      <a href={to} {...props}>
        {children}
      </a>
    );
  }
  return (
    <GatsbyLink to={to} {...props}>
      {children}
    </GatsbyLink>
  );
};

export default Link;
